import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';

/**
 * Error interceptor - handles HTTP errors globally
 * Simplified version for public app (no auth service dependency)
 */
export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // Handle specific error cases if needed
      // For public app, we might want to show toast notifications or handle errors differently
      switch (error.status) {
        case 401:
        case 403:
          // Handle unauthorized/forbidden errors if needed
          // In public app, these might be handled differently than in management portal
          break;
      }

      return throwError(() => error);
    }),
  );
};
